import omit from 'lodash/omit'
import omitBy from 'lodash/omitBy'
import pick from 'lodash/pick'
import pickBy from 'lodash/pickBy'
import * as pathToRegexp from 'path-to-regexp'

import { CLEAN_SYMBOL } from './constants'
import { stripQueryFromPattern } from './patternUtils'
import { parseQueryString, toQueryString } from './queryString'
import { getRoutingStore } from './routingStore'

const getLocationQuery = () => parseQueryString(getRoutingStore().location.search)

const ensureLeft = (str: string, prefix: string) => (str.startsWith(prefix) ? str : prefix + str)

export const interpolateUrl = (pattern: string, params: any) => {
  const pathPattern = stripQueryFromPattern(pattern)
  const namesOfPathKeys = pathToRegexp
    .parse(pathPattern)
    .filter((token): token is pathToRegexp.Key => typeof token === 'object')
    .map(it => it.name)
  // compile() URI-encodes param values itself, so path params are passed raw
  const toPath = pathToRegexp.compile(pathPattern)

  const queryParams = omit(params, namesOfPathKeys)
  const pathParams = pick(params, namesOfPathKeys)

  const isIgnorable = (value: any) =>
    value === null ||
    value === undefined ||
    value === '' ||
    value === CLEAN_SYMBOL ||
    value === 'false' ||
    value === false

  const query = toQueryString({
    ...omitBy(queryParams, isIgnorable),
    ...pickBy(getLocationQuery(), (value, key: string) => key.startsWith('utm')),
  })

  return toPath(pathParams) + (query && ensureLeft(query, '?'))
}
